var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-box"},[(_vm.title)?_c('h2',[_c('span',{staticClass:"glow-text"},[_vm._v(_vm._s(_vm.title))])]):_vm._e(),_c('p',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }